import React from "react"
import { componentStyles, ExternalLink } from "@mallardbay/lib-react-components"

import Box from "~components/shared/todo-lib-react-components/box"
import { Text } from "~components/shared/todo-lib-react-components/text"
import COPY from "~config/copy-constants"
import { getManageListingPageUrl } from "~utils/navigation-helpers"

interface Props {
    readonly title?: string | null
    readonly isOwner?: boolean
    readonly listingId: string
}

export default function ListingTitleHeader({
    title,
    isOwner,
    listingId,
}: Props) {
    const styles = useStyles()
    const manageListingPageUrl = getManageListingPageUrl(listingId)

    return (
        <Box style={styles.root}>
            {title && <Text style={styles.title}>{title}</Text>}
            {isOwner && (
                <ExternalLink href={manageListingPageUrl}>
                    {COPY.EDIT_THIS_LISTING}
                </ExternalLink>
            )}
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            display: { base: "inline-block", md: "flex" },
            justifyContent: { base: "normal", md: "space-between" },
            alignItems: { base: "normal", md: "flex-end" },
        },
        title: {
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            fontWeight: 600,
            fontSize: { base: "20px", md: "26px" },
            textTransform: "capitalize",
        },
    })
}
